import { render, staticRenderFns } from "./FQDNTable.vue?vue&type=template&id=ebfbae98&scoped=true"
import script from "./FQDNTable.vue?vue&type=script&lang=js"
export * from "./FQDNTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfbae98",
  null
  
)

export default component.exports